/**
 * admin-console Chakra UI v3 テーマ設定
 */
import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { colors, semanticColors } from './colors';
import { fonts, fontSizes, fontWeights, lineHeights, textStyles } from './typography';

const config = defineConfig({
  theme: {
    tokens: {
      colors,
      fonts,
      fontSizes,
      fontWeights,
      lineHeights,
      radii: {
        sm: { value: '6px' },
        md: { value: '10px' },
        lg: { value: '12px' },
      },
      sizes: {
        input: { value: '2.5rem' }, // 40px - 管理画面向けコンパクトサイズ
      },
    },
    semanticTokens: {
      colors: semanticColors,
    },
    textStyles,
  },
});

export const system = createSystem(defaultConfig, config);
